import React from 'react'
import { LuCircleAlert } from 'react-icons/lu'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

const ServiceNewWarning: React.FC = () => {
  return (
    <>
      {' '}
      <Tooltip>
        <TooltipTrigger asChild>
          <LuCircleAlert className="inline-block size-3" />
        </TooltipTrigger>

        <TooltipContent>
          Selected service is not yet added in your services. It will be added
          automatically upon importing of this referral.
        </TooltipContent>
      </Tooltip>
    </>
  )
}

export default ServiceNewWarning
